/**
 * @generated SignedSource<<6705826038399fe105d1b309dd55fb65>>
 * @relayHash 94f40e9b07bbb32bc7cb3e751cae9955
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/570.0.0-2026-07-24T17:42:10.186Z/useHasUnreadNotificationsQuery

import { ConcreteRequest } from 'relay-runtime';
export type useHasUnreadNotificationsQuery$variables = {
  userId: string;
};
export type useHasUnreadNotificationsQuery$data = {
  readonly viewer: {
    readonly actionRequiredOrders: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly serviceId: string | null;
        } | null;
      } | null> | null;
      readonly totalResults: number | null;
    } | null;
    readonly user: {
      readonly conversationSummary: {
        readonly unread: number | null;
        readonly unreadActiveOffers: number | null;
      } | null;
    } | null;
  };
};
export type useHasUnreadNotificationsQuery = {
  response: useHasUnreadNotificationsQuery$data;
  variables: useHasUnreadNotificationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Summary",
  "kind": "LinkedField",
  "name": "conversationSummary",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unread",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unreadActiveOffers",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "buyerId.0",
        "variableName": "userId"
      }
    ],
    "kind": "ListValue",
    "name": "buyerId"
  },
  {
    "kind": "Literal",
    "name": "viewName",
    "value": "buyer.bomtActionRequired"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalResults",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useHasUnreadNotificationsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "actionRequiredOrders",
            "args": (v3/*:: as any*/),
            "concreteType": "TransactionConnection",
            "kind": "LinkedField",
            "name": "transactions",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TransactionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Transaction",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useHasUnreadNotificationsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v6/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "actionRequiredOrders",
            "args": (v3/*:: as any*/),
            "concreteType": "TransactionConnection",
            "kind": "LinkedField",
            "name": "transactions",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TransactionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Transaction",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*:: as any*/),
                      (v6/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v6/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ferrum/570.0.0-2026-07-24T17:42:10.186Z/useHasUnreadNotificationsQuery",
    "metadata": {},
    "name": "useHasUnreadNotificationsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0bdef5f3c45a9e28defdf8d12909ee64";

export default node;
